<template>
  <div class="flex flex-col w-full items-center justify-center bg-white border rounded border-gray-200 shadow-sm px-5 py-7 mb-5">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="w-24 h-24 sm:w-32 sm:h-32 text-green-organization"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    <span class="text-xl sm:text-3xl py-2 sm:py-5 px-2 sm:px-10 text-center text-gray-500">
      Seu ticket foi criado com sucesso :)
    </span>
  </div>
</template>

<script>
export default {
  name: 'ExternalTicketCreated'
}
</script>
